import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { PaginationComponent } from '@app/infrastructure/data-list/pagination/pagination.component';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
	declarations: [PaginationComponent],
	exports: [PaginationComponent],
	imports: [
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		MatOptionModule,
		MatSelectModule,
		PipesModule,
		ReactiveFormsModule,
	],
})
export class PaginationModule {}
